import { z } from 'zod'
import { MailboxDelegationInfo } from './MailboxDelegation'

export const MailboxLoginRequest = z.object({
  email: z.string().email(),
  password: z.string(),
  token: z.string()
})

export type MailboxLoginRequest = z.infer<typeof MailboxLoginRequest>

export const MailboxLoginResponse = z.object({
  token: z.string(),
  expires_at: z.string(),
  email: z.string(),
  account_id: z.number(),
  delegations: z.array(MailboxDelegationInfo).optional()
})

export type MailboxLoginResponse = z.infer<typeof MailboxLoginResponse>

export const MailboxSelfInfo = z.object({
  id: z.string(),
  email: z.string(),
  quota_bytes: z.number().optional(),
  used_bytes: z.number().optional(),
  sender_addresses: z.array(z.string()).optional(),
  auto_reply_active: z.boolean().optional()
})

export type MailboxSelfInfo = z.infer<typeof MailboxSelfInfo>
